export const GET_JSON_VIEW_ACTIONS_COUNT = ({ copy }: { copy?: boolean }) => (copy ? 3 : 2);
export const SEARCH_ACTION_DATA_TYPE = "search-action";
export const BASE_SEPARATOR = "~~~|~!|!~|~~~";
export const HIDE_ROWS_COUNT = 2;
export const HIDE_ROWS_IDENTICAL_COUNT = 10;
export const OPENING_ROWS_COUNT = 25;
export const CUT_VALUE_LENGTH = 100;
